<template>
  <v-card flat class="fill-height" width="100%">
    <v-container fluid>
      <v-card-title>Moment - {{section.name }}</v-card-title>

      <v-card-text class="pt-2 mx-0 px-0">
        <v-expansion-panels multiple :readonly="disabledPanel" v-model="panel">
          <v-expansion-panel v-for="(detail,index) in section.details" :key="index">
            <v-expansion-panel-header expand-icon class="panel-header" v-if="edit=='editElements'">
              <TransformerTextField
                label="Moment"
                placeholder="Moment"
                :item="detail"
                type="element"
                :edit="true"
                :sectionId="section.id"
                @textUpdated="reloadAfterChange"
              />
            </v-expansion-panel-header>
            <v-expansion-panel-header
              class="panel-header"
              v-if="edit!='editElements'"
            >{{detail.name}}</v-expansion-panel-header>
            <v-expansion-panel-content :disabled="disabledPanel">
              <div
                v-for="(part,index) in (detail.parts ? detail.parts : [])"
                :key="index"
                class="panel-content-part py-2 px-2"
              >
                <template v-if="part">
                  <v-icon color="secondary">
                    {{
                    getIcon(part.id)
                    }}
                  </v-icon>
                  {{ part.name }}
                  <ul v-if="edit!='editItems'">
                    <li
                      v-for="item in part.items"
                      :key="item.id"
                      class="panel-content-item py-2 px-2"
                    >{{ item.text }}</li>
                  </ul>
                  <ul v-if="edit=='editItems'">
                    <li
                      v-for="item in part.items"
                      :key="item.id"
                      class="panel-content-item py-2 px-2"
                    >
                      <TransformerTextField
                        label="Beskrivning"
                        placeholder="Beskrivning"
                        :item="item"
                        :partId="part.id"
                        :detailId="detail.id"
                        :edit="true"
                        type="item"
                        @textUpdated="reloadAfterChange"
                      />
                    </li>
                  </ul>
                </template>
              </div>
              <template v-if="detail.parts && detail.parts.length">
                <v-card flat class="pt-8 text-center">
                  <v-btn
                    v-if="editItemBtn"
                    @click="editClick('editItems')"
                    type="submit"
                    color="primary"
                  >Ändra</v-btn>
                  <v-btn
                    v-if="!editItemBtn"
                    @click="editClick('cancelItems')"
                    type="submit"
                    color="primary"
                  >Avbryt</v-btn>
                </v-card>
              </template>
              <transition name="fade">
                <AddItem
                  v-if="showAddElement && detail"
                  :elementId="detail.id"
                  @addItemClick="addItemClick"
                ></AddItem>
              </transition>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <template>
          <v-card
            v-if="section.details && section.details.length"
            flat
            class="fill-height text-center pt-8"
          >
            <v-btn
              v-if="edit!='editElements'"
              @click="editClick('editElements')"
              type="submit"
              color="primary"
            >Ändra</v-btn>
            <v-btn
              v-if="edit=='editElements'"
              @click="editClick('')"
              type="submit"
              color="primary"
            >Avbryt</v-btn>
          </v-card>
        </template>
        <transition name="fade">
          <AddElement
            v-if="showAddElement"
            @addElementClick="addElementClick"
            @editClick="editClick"
          ></AddElement>
        </transition>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
//import SEQFLevelBoxes from '@/components/seqfadministration/SEQFLevelBoxes'
import API from '@/services/api.js'
import AddElement from '@/components/seqfadministration/AddElement.vue'
import AddItem from '@/components/seqfadministration/AddItem.vue'
import TransformerTextField from '@/components/seqfadministration/TransformerTextField.vue'
// @group Common
// Elements component
export default {
  name: 'Elements',
  data: () => ({
    showAddElement: true,
    elementName: '',
    panel: [],
    editItemBtn: true,
    disabledPanel: false,
    removeNullProps: Object,
    type: '',
    edit: '',
    editElements: false,
    icons: [
      {
        id: 1,
        icon: 'mdi-information'
      },
      {
        id: 2,
        icon: 'mdi-lightbulb-outline'
      },
      {
        id: 3,
        icon: 'mdi-tools'
      },
      {
        id: 4,
        icon: 'mdi-emoticon-cool-outline'
      }
    ]
  }),
  props: {
    //element section
    section: {
      // `Object`
      type: Object,
      // The default value is: `empty object`
      default: {}
    }
  },
  created() {
    //console.log(JSON.stringify(this.section))
  },
  methods: {
    reloadAfterChange(e) {
      // Fire reloadAfterChange event
      // @arg The argument is object section
      this.$emit('reloadAfterChange', {
        responseId: e.responseId,
        sectionId: this.section.id,
        professionId: this.section.professionId
      })
    },
    getShorter(value) {
      if (!value && typeof value != 'string') return ''
      if (value.length > 7) return value.substring(0, 8) + '...'
      else return value
    },
    getIcon(id) {
      return this.icons.find(x => x.id === id).icon
    },
    editElementsClick() {
      this.edit = 'editElements'
    },
    clickEditItemsCancel() {
      this.editItemBtn = true
      this.editClick('')
    },
    editClick(e) {
      this.edit = e
      //alert(e)
      if (e == 'editElements') {
        this.disabledPanel = true
        this.panel = []
      } else if (e == 'editItems') {
        this.editItemBtn = false
      } else if (e == 'cancelItems') {
        this.editItemBtn = true
      } else {
        this.disabledPanel = false
        this.editItemBtn = true
      }
    },
    addElementClick(newValue) {
      this.elementName = newValue

      API.createDetail({
        data: {name: newValue, sectionId: this.section.id}
      })
        .then(response => {
          this.$events.fire('showInfo', "'" + newValue + "' sparad.")

          this.reloadAfterChange({
            responseId: response.data.id
          })
        })
        .catch(error => {
          this.reloadAfterChange({
            responseId: 0
          })
          console.log('There was an error:', error.response)
        })
    },
    addItemClick(partId, newValue, elementId) {
      var msg = this.getShorter(newValue)
      API.createItem({
        data: {text: newValue, partId: partId, detailId: elementId}
      })
        .then(response => {
          this.$events.fire('showInfo', "'" + msg + "' sparad.")
          this.reloadAfterChange({
            responseId: response.data.id
          })
          //this.elementAdded(newValue);
        })
        .catch(error => {
          this.id = 0
          console.log('There was an error:', error.response)
        })
    }
  },

  components: {
    //  SEQFLevelBoxes
    AddElement,
    TransformerTextField,
    AddItem
  }
}
</script>
<style lang="scss">
.panel-header {
  //font-weight: bold;
  font-size: 18px;
  height: 70px;
}
.panel-content-part {
  border-bottom: 1px solid #eee;
  font-size: 16px;
  font-style: italic;
  &:last-child {
    border: none;
  }
  ul {
    list-style: none;
    li {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
    }
  }
}
</style>